var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("f7-page", [
    _c(
      "div",
      { staticClass: "main-content h-100" },
      [
        _c("b-container", { class: { "w-60": _vm.getCols < 5 } }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center h-100vh",
            },
            [
              _c(
                "b-row",
                { attrs: { "align-h": "start", cols: _vm.getCols } },
                _vm._l(_vm.data, function (action, index) {
                  return _c(
                    "b-col",
                    { key: action.id },
                    [
                      _c(
                        "b-container",
                        {
                          staticClass: "homeButton",
                          class: _vm.getColor(index),
                          attrs: { fluid: "" },
                          on: {
                            click: function ($event) {
                              return _vm.redirect(action.link)
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "9" } }, [
                                _c("i", {
                                  staticClass: "homeButtonIcon fa",
                                  class: action.icon,
                                }),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "d-flex-end h-50" },
                            [
                              _c("b-col", { attrs: { cols: "9" } }, [
                                _c(
                                  "div",
                                  { staticClass: "w-100 fs-16px text-white" },
                                  [_vm._v(_vm._s(_vm.$t(action.title)))]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }